
import React from 'react';

export default () => (
  <div>
    <p>
      I can do system administration tasks on CentOS, Debian or Ubuntu-based
      distributions. It will take me some time to manage an Arch or Gentoo system but it's not
      impossible.

      I built a tool that deploys a Debian system to a remote server with focus on security.
      This tool uses the following technologies:<br /><br />

      Ansible, Bash, Python.<br /><br />

      This tool will install and configure the following:<br /><br />

      SSH, Fail2Ban, AppArmor, Lynis, OSSEC, Nginx, a recent version of Ruby on Rails environment using rbenv
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/stacks/more_info/Linux.js